<template>
  <div>
    <!-- delete Account modal -->
    <modal v-show="isModalVisible" @close="closeModal" footer>
      <template v-slot:title>
        <h5>Delete Staff Account</h5>
      </template>
      <template v-slot:body>
        <div class="pt-5 text-center">
          <div class="icon text-danger">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather-user-x"
              style="width: 60px; height: 60px;"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="8.5" cy="7" r="4"></circle>
              <line x1="18" y1="8" x2="23" y2="13"></line>
              <line x1="23" y1="8" x2="18" y2="13"></line>
            </svg>
          </div>
          <h3 class="mt-5 mb-4 font-weight-600">Extremely important</h3>
          <p>
            We will immediately delete all of <strong>{{ user.name }}</strong
            >'s record from the the database. This action can not be undone. are
            you sure you want to do this?
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="btn text-danger"
          @click.prevent="deleteRecord()"
          :disabled="deleteRecordLoading"
        >
          <span v-if="deleteRecordLoading">Deleting Record...</span>
          <span v-else>Delete Record</span>
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal"
        >
          Cancel
        </button>
      </template>
    </modal>

    <div
      v-if="loadUserProfile"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting user profile ready...</h3>
        </div>
      </div>
    </div>

    <div class="rider--main-content">
      <router-link
        v-if="!mustChangePassword"
        :to="{ name: 'Dashboard' }"
        class="arrow_text"
      >
        <chevron-left-icon
          size="1.5x"
          class="custom-class"
          style="vertical-align: top;"
        ></chevron-left-icon>
        <span class="back">Back</span>
      </router-link>

      <!-- User Profile -->
      <h1 class="mt-2 mb-3 font-regular">
        {{ mustChangePassword ? "Change your password" : "User Name" }}
      </h1>

      <div v-if="mustChangePassword" class="alert alert-warning mb-4">
        Your password was reset. You must set a new password before you can
        continue using the admin portal.
      </div>

      <div class="row mb-5">
        <div class="col-lg-12">
          <CScrollbar
            class="nav nav-tabs nav-overflow header-tabs"
            :settings="psSettings"
            tag="ul"
          >
            <!-- tabs -->
            <!-- <li class="nav-item">
              <a 
                href="javascript:void(0)" 
                class="nav-link"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ?  'active' : '']"
                >
                General Information
              </a>
            </li> -->

            <li class="nav-item">
              <a
                href="javascript:void(0)"
                class="nav-link"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
              >
                Change Password
              </a>
            </li>
            <li class="nav-item" v-if="!mustChangePassword">
              <a
                href="javascript:void(0)"
                class="nav-link"
                v-on:click="activetab = 3"
                v-bind:class="[activetab === 3 ? 'active' : '']"
              >
                Change PIN
              </a>
            </li>
          </CScrollbar>
        </div>
      </div>

      <!-- General Information -->
      <div class="row" v-if="activetab === 1">
        <div class="col-md-4">
          <div class="card card--no-shadow card-profile">
            <div class="card-content">
              <div class="card-body position-relative d-flex flex-column">
                <div class="mx-auto position-relative">
                  <img
                    :src="adminObject.avatar"
                    alt=""
                    class="card--profile-image avatar rounded-circle"
                    :style="uploadingUserImage ? 'opacity: .5;' : ''"
                  />

                  <img
                    src="../assets/img/approved 1.svg"
                    alt=""
                    class="card--profile-badge"
                  />
                </div>
                <div class="mt-2 card--profile-name text-center">
                  <button
                    class="btn btn-secondary"
                    type="button"
                    @click="onPickProfileImage"
                  >
                    <span v-if="uploadingUserImage">
                      Uploading Profile picture...
                    </span>
                    <span v-else>
                      <camera-icon
                        size="1.5x"
                        class="custom-class"
                        style="vertical-align: bottom; margin-right: 4px;"
                      ></camera-icon>
                      <span> Change profile picture</span>
                    </span>
                  </button>
                  <input
                    type="file"
                    class="upload"
                    ref="fileInput"
                    accept="*"
                    style="display: none;"
                    @change="onFilePickedProfileImage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-8">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Profile Information</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form @submit.prevent="updateUserProfile">
                  <!-- general information -->
                  <div class="actions-toolbar pb-2">
                    <h5 class="actions-title">General Information</h5>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="user_firstname">Full Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="user.name"
                          placeholder="Full Name"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="user_email">Email</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="user.email"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="user_phone">Phone</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="user.phone_number"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="user_address">Address</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="user.address"
                          placeholder="Address"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="user_city">City</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="user.city"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="user_state">State</label>
                        <select
                          name="state"
                          id="state"
                          v-model="user.state_id"
                          class="form-control"
                        >
                          <option value=""></option>
                          <option
                            :value="state.id"
                            :selected="state.id === adminObject.state_id"
                            v-for="state in states"
                            :key="state.id"
                            >{{ state.name }}</option
                          >
                        </select>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="button"
                    :disabled="updateUserLoading"
                  >
                    <span class="custom-loader" v-if="updateUserLoading">
                      <loader-icon
                        size="1.5x"
                        class="custom-class"
                      ></loader-icon>
                      <span style="font-weight: 600; text-transform: initial;"
                        >Updating User Profile...</span
                      >
                    </span>
                    <span v-else>Save Changes</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- change password -->
      <div class="row" v-if="activetab === 2">
        <div class="col-md-8">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Change Password</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form @submit.prevent="updateUserPassword">
                  <div class="actions-toolbar pb-2">
                    <h5 class="actions-title">Change Password</h5>
                  </div>
                  <div class="form-group">
                    <label for="old_password">Old Password</label>
                    <input
                      type="password"
                      v-model.trim="old_password"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label for="new_password">New Password</label>
                    <input
                      type="password"
                      v-model.trim="new_password"
                      class="form-control"
                    />
                    <small class="form-text text-muted">
                      At least 8 characters, including uppercase, lowercase, a
                      number, and a special character (@$!%*#.?&).
                    </small>
                  </div>
                  <div class="form-group">
                    <label for="confirm_password">Confirm New Password</label>
                    <input
                      type="password"
                      v-model.trim="confirm_password"
                      class="form-control"
                    />
                  </div>

                  <button
                    type="submit"
                    class="button"
                    :disabled="updatePasswordLoading"
                  >
                    <span class="custom-loader" v-if="updatePasswordLoading">
                      <loader-icon
                        size="1.5x"
                        class="custom-class"
                      ></loader-icon>
                      <span style="font-weight: 600; text-transform: initial;"
                        >Updating Password...</span
                      >
                    </span>
                    <span v-else>Update Password</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="activetab === 3">
        <div class="col-md-8">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Change PIN</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form @submit.prevent="updateUserPin">
                  <div class="actions-toolbar pb-2">
                    <h5 class="actions-title">Change PIN</h5>
                  </div>
                  <div class="form-group">
                    <label for="old_password">Old PIN</label>
                    <input
                      type="password"
                      v-model.trim="old_pin"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label for="new_password">New PIN</label>
                    <input
                      type="password"
                      v-model.trim="new_pin"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label for="confirm_password">Confirm New PIN</label>
                    <input
                      type="password"
                      v-model.trim="confirm_pin"
                      class="form-control"
                    />
                  </div>

                  <button
                    type="submit"
                    class="button"
                    :disabled="updatePasswordLoading"
                  >
                    <span class="custom-loader" v-if="updatePasswordLoading">
                      <loader-icon
                        size="1.5x"
                        class="custom-class"
                      ></loader-icon>
                      <span style="font-weight: 600; text-transform: initial;"
                        >Updating PIN...</span
                      >
                    </span>
                    <span v-else>Update PIN</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CScrollbar from "@/components/CScrollbar";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { setTimeout } from "timers";

export default {
  name: "Profile",
  // props: {
  //   slug: {
  //     type: [String, Number],
  //     required: true
  //   }
  // },
  components: {
    CScrollbar
  },
  inject: {
    state: {
      default: false
    }
  },
  computed: {
    ...mapGetters(["adminObject", "userObj"]),
    mustChangePassword() {
      const user = this.userObj || {};
      return user.must_change_password === true || user.must_change_password === 1;
    },
    psSettings() {
      //Todo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollx:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    }
  },
  data() {
    return {
      deleteRecordLoading: false,
      isModalVisible: false,
      uploadingUserImage: false,
      loadUserProfile: false,
      activetab: 2,
      updateUserLoading: false,
      updatePasswordLoading: false,
      user: {},
      roles: [],
      states: [],
      old_password: "",
      new_password: "",
      confirm_password: "",
      old_pin: "",
      new_pin: "",
      confirm_pin: ""
    };
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
    },
    showModal() {
      this.isModalVisible = true;
    },
    async getAllRoles() {
      try {
        const response = await ApiService.get("backend/policy/roles");
        this.roles = response.data.data;
        console.log("role", response);
      } catch (error) {
        console.log(error.response);
      }
    },
    async getStates() {
      try {
        const response = await ApiService.get("general/states");
        this.states = response.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getInstance() {
      try {
        const response = await ApiService.get("backend/instance");
        this.user = response.data.data;
        console.log(this.user);
      } catch (error) {
        console.log(error.response);
      }
    },
    onPickProfileImage() {
      this.$refs.fileInput.click();
    },
    onFilePickedProfileImage(event) {
      const files = event.target.files;
      //
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.adminObject.avatar = fileReader.result;

        //upload image to end point

        let data = {
          profile_image: this.adminObject.avatar
        };

        this.uploadProfilePicture(data);
      });

      fileReader.readAsDataURL(files[0]);
    },
    async uploadProfilePicture(data) {
      try {
        this.uploadingUserImage = true;
        const response = await ApiService.post(
          `backend/users/upload-avatar/${this.user.admin_id}`,
          data
        );

        this.uploadingUserImage = false;

        // fire swal
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        this.$store.commit("setAdmin", response.data.data);
      } catch (error) {
        this.uploadingUserImage = false;
        console.log(error.response);

        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async updateUserProfile() {
      let data = {
        name: this.user.name,
        email: this.user.email,
        phone_number: this.user.phone_number,
        state_id: this.user.state_id,
        role: this.user.role,
        city: this.user.city,
        address: this.user.address
      };

      try {
        this.updateUserLoading = true;
        const response = await ApiService.post(`backend/update-profile`, data);
        this.updateUserLoading = false;

        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        this.$store.commit("setAdmin", response.data.data);
      } catch (error) {
        this.updateUserLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async deleteRecord() {
      try {
        this.deleteRecordLoading = true;
        const response = await ApiService.customRequest({
          method: "delete",
          url: `backend/users/delete/${this.adminObject.admin_id}`
        });

        this.deleteRecordLoading = false;

        this.isModalVisible = false;

        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        setTimeout(() => this.$router.push({ name: "Login" }), 3000);
      } catch (error) {
        this.deleteRecordLoading = false;
        this.isModalVisible = false;
        console.log(error.response);

        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async updateUserPassword() {
      try {
        let data = {
          old_password: this.old_password,
          new_password: this.new_password,
          confirm_password: this.confirm_password
        };
        this.updatePasswordLoading = true;
        const response = await ApiService.post(
          `user/update-profile-password`,
          data
        );
        this.updatePasswordLoading = false;
        const wasForced = this.mustChangePassword;
        const updatedUser = response.data && response.data.data;
        if (updatedUser) {
          this.$store.commit("setUser", updatedUser);
        }
        Swal.fire({
          title: "Success",
          text: response.data.message || response.data.response_message || "Password updated",
          timer: 3000,
          icon: "success",
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.old_password = "";
        this.new_password = "";
        this.confirm_password = "";
        if (wasForced) {
          setTimeout(() => this.$router.push("/dashboard"), 1200);
        }
      } catch (error) {
        this.updatePasswordLoading = false;
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        this.old_password = "";
        this.new_password = "";
        this.confirm_password = "";
      }
    },
    async updateUserPin()
    {
      try {
        let data = {
          old_pin: this.old_pin,
          new_pin: this.new_pin,
          confirm_pin: this.confirm_pin
        };
        this.updatePasswordLoading = true;
        const response = await ApiService.post(
          `user/update-profile-pin`,
          data
        );
        this.updatePasswordLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          timer: 3000,
          icon: "success",
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.old_pin = "";
        this.new_pin = "";
        this.confirm_pin = "";
      } catch (error) {
        this.updatePasswordLoading = false;
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        this.old_pin = "";
        this.new_pin = "";
        this.confirm_pin = "";
      }
    }
  },
  mounted() {
    if (this.mustChangePassword) {
      this.activetab = 2;
      return;
    }
    // console.log(this.adminObject)
    this.getInstance();
    this.getAllRoles();
    this.getStates();
    console.log("admin", this.adminObject);
    // this.user = this.adminObject
    // console.log(this.user)
  }
};
</script>

<style scoped>
.card-profile .card--profile-image {
  width: 9rem;
  height: 9rem;
  border: 0.1875rem solid #fff;
  display: block;
  /* transform: translateY(-50%); */
}

.card-profile .card--profile-badge {
  position: absolute;
  right: 0;
  bottom: 0;
  background: #fff;
  border-radius: 50%;
  height: 3.2rem;
  padding: 0.5rem;
}

.header-tabs {
  margin-bottom: -1.5rem;
  border-bottom-width: 0;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-overflow {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 1px;
}

.nav-tabs {
  border-bottom: 1px solid #e3ebf6;
  display: -webkit-box;
}

.nav-tabs .nav-item:first-child {
  margin-left: 0;
}

.nav-tabs .nav-item:first-child .nav-link {
  padding-left: 0;
}

.nav-tabs .nav-item {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.nav-tabs .nav-link.active {
  color: #32417e !important;
  border-bottom: 2px solid #32417e !important;
  background-color: transparent;
  border-color: transparent transparent #32417e !important;
}

.nav-tabs .nav-link:not(.active) {
  color: #95aac9;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-tabs .nav-link {
  padding: 1rem 0;
  border-bottom: 1px solid transparent;
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 0;
}
</style>
